import Avatar from '-/Custom/Avatar';
import * as Header from '-/Custom/Header';
import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import { Share as RNShare } from 'react-native';
import { useQuery } from 'urql';
import CopyTextButton from '@/components/Custom/CopyTextButton';
import Item from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import Icon from '@/components/Unistyles/Icon';
import { graphql } from '@/gql/graphql';
import useHeaderButton from '@/hooks/useHeaderButton';
import useIsSharingAvailable from '@/hooks/useIsSharingAvailable';
import getAvatarText from '@/utils/getAvatarText';
import getTeamInviteLink from '@/utils/getTeamInviteLink';

const GetTeamCreateDone = graphql(/* GraphQL */ `
  query GetTeamCreateDone($teamId: uuid!) {
    team_by_pk(id: $teamId) {
      id
      title
      home_primary_color
      avatar_id
    }
  }
`);

const GetTeamCreateDoneInviteCode = graphql(/* GraphQL */ `
  query GetTeamCreateDoneInviteCode($teamId: uuid!) {
    invite_entry_code(args: { kind: team, entity_id: $teamId }) {
      code
    }
  }
`);

export default function TeamCreateDone() {
  const isSharingAvailable = useIsSharingAvailable();
  const { teamId } = useLocalSearchParams<{
    teamId: string;
  }>();
  const [{ data }] = useQuery({
    query: GetTeamCreateDone,
    variables: {
      teamId: teamId || '',
    },
  });
  const team = data?.team_by_pk;
  const [{ data: inviteCodeData }] = useQuery({
    query: GetTeamCreateDoneInviteCode,
    variables: { teamId: team?.id || '' },
    pause: !team?.id,
    requestPolicy: 'network-only',
  });
  const inviteCode = inviteCodeData?.invite_entry_code[0]?.code;
  const inviteLink = team && inviteCode ? getTeamInviteLink(inviteCode) : null;
  const onPressInvite = () => {
    if (inviteLink) {
      RNShare.share({
        message: `Join ${data?.team_by_pk?.title} on 1Time Sports \n\n ${inviteLink}`,
      });
    }
  };
  const { back } = useRouter();
  const headerRight = useHeaderButton(back, 'Done');
  return (
    <>
      <Stack.Screen
        options={{
          headerRight,
          title: 'All Set!',
          headerBackVisible: false,
        }}
      />
      <Header.Toolbar>
        <Header.Row>
          <Avatar
            id={team?.avatar_id || ''}
            name={getAvatarText(team?.title)}
            color={team?.home_primary_color}
            size="xl"
          />
          <Header.Title>{team?.title}</Header.Title>
        </Header.Row>
      </Header.Toolbar>
      <Header.ColorBar backgroundColor={team?.home_primary_color || ''} />
      {isSharingAvailable ? (
        <Item onPress={onPressInvite}>
          <Icon name="share-outline" />
          <Text>Share Invite Link…</Text>
        </Item>
      ) : null}
      {inviteLink ? (
        <CopyTextButton
          defaultButtonText="Copy Invite Link…"
          textToCopy={inviteLink}
        />
      ) : null}
    </>
  );
}
